const ADD_AVAILABILITY_TO_CONTRACTOR = '/addAvailabilityToContractor';
const SYNC_AVAILABILITY_TO_CONTRACTOR = '/syncAvailabilityToContractor';
module.exports = {
    getSuggestedAvailability: function getSuggestedAvailability(bookingId, dataEndDate =null ,  startTime = null ,     startDate= null, fieldworkerId, username) {
        return window.axios.get(ADD_AVAILABILITY_TO_CONTRACTOR, {
            params: {
                'booking_id': bookingId,
                'contractor_id': fieldworkerId,
                'start_date': startDate,
            }
        });
    },

    syncSuggestedAvailability: function syncSuggestedAvailability(formData){
        return window.axios.post(SYNC_AVAILABILITY_TO_CONTRACTOR, formData, {
            responseType: 'json', // default
        });
    }
};
